import { Dialog, DialogContent } from '@mui/material'
import { Dispatch, SetStateAction, useEffect } from 'react';

import CancelIcon from '@mui/icons-material/Cancel';


interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

const ModalCloseDialog = ({ isOpen, setIsOpen }: Props) => {

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(false);
    }, 3000);

    return () => clearTimeout(timer); // Limpia el temporizador cuando el componente se desmonte (se cerraba constantemente)
  }, [setIsOpen]);

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} >
      <DialogContent
        className='font-semibold text-center'
      >
        <CancelIcon sx={{color: 'red'}} /> Es necesario completar tu evaluación para poder asignarte un nuevo plan de entrenamiento y alimentación.
      </DialogContent>
    </Dialog>
  )
}

export default ModalCloseDialog;
